<template>
  <div class="box_clas">
    <el-steps v-if="!isEditCluster" :active="clusterActive" align-center class="base-margin__bottom-10"
              finish-status="success">
      <el-step :title="$t('customCluster.createCluster.step.clusterInfo')"></el-step>
      <el-step :title="$t('customCluster.createCluster.step.ipHostnameMapping')"></el-step>
      <el-step :title="$t('customCluster.createCluster.step.previewIp')"></el-step>
      <el-step :title="$t('customCluster.createCluster.step.script')"></el-step>
    </el-steps>
    <el-form v-show="clusterActive === 0" label-position="left" ref="form" v-loading="createClusterLoading" :model="form"
             :rules="createClusterRules"
             label-width="100px">
      <el-form-item :label="$t('customCluster.createCluster.form.subclusterName')" prop="name">
        <el-input v-model="form.name" :placeholder="$t('customCluster.createCluster.placeholder.enterName')"></el-input>
      </el-form-item>
      <el-form-item v-if="!isEditCluster" :label="$t('customCluster.createCluster.form.privateNetwork')" prop="region">
        <div class="base-flex base-width_fullscreen">
          <el-select
            v-model="form.region"
            :placeholder="$t('customCluster.createCluster.placeholder.selectRegion')"
            class="formItem__select-short base-margin__right-20"
            filterable
            @change="changeRegion"
          >
            <el-option
              v-for="item in regionList"
              :key="item.Region"
              :label="item.RegionName"
              :value="item.Region"
            ></el-option>
          </el-select>
          <div class="base-flex base-flex__1">
            <el-select
              v-model="form.vpcId"
              :placeholder="$t('customCluster.createCluster.placeholder.selectPrivateNetwork')"
              filterable
              @change="changeVpc"
            >
              <el-option
                v-for="item in vpcList"
                :key="item.VpcId"
                :label="`${item.VpcName} | ${item.VpcId} | ${item.CidrBlock}`"
                :value="item.VpcId"
              ></el-option>
            </el-select>
            <div class="base-margin__left-10">
              <i
                :class="`base-color__light_blue base-font-size__16px base-cursor__pointer ${getVpcListLoading ? 'el-icon-loading' : 'el-icon-refresh'}`"
                @click="getVpcList"></i>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item :label="$t('customCluster.createCluster.form.image')" prop="imageId">
        <div class="base-width_fullscreen">
          <div class="base-flex base-margin__bottom-10">
            <el-select
              v-model="form.imageType"
              :placeholder="$t('customCluster.createCluster.placeholder.imageType')"
              class="formItem__select-short base-margin__right-20"
              @change="changeImageType('imageType')"
            >
              <el-option :label="$t('customCluster.createCluster.option.customImage')" value="PRIVATE_IMAGE"></el-option>
              <el-option :label="$t('customCluster.createCluster.option.publicImage')" value="PUBLIC_IMAGE"></el-option>
              <el-option :label="$t('customCluster.createCluster.option.sharedImage')" value="SHARED_IMAGE"></el-option>
            </el-select>
            <el-select
              v-model="imagePlatformType"
              :placeholder="$t('createNode.selectImageType')"
              class="formItem__select-short base-margin__right-20"
              @change="changeImageType('imagePlatform')"
            >
              <el-option v-for="item in imageTypeList" :key="item.value" :label="item.text" :value="item.value"></el-option>
            </el-select>
          </div>
          <el-select
            v-model="form.imageId"
            :placeholder="$t('customCluster.createCluster.placeholder.selectImage')"
            filterable
            @change="changeImage"
          >
            <el-option
              v-for="item in imageList"
              :key="item.ImageId"
              :label="`${item.ImageId} | ${item.ImageName} | ${item.ImageSize} GiB`"
              :value="item.ImageId"
            ></el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item v-if="!isEditCluster" :label="$t('customCluster.createCluster.form.subnetInfo')" prop="zone">
        <div class="base-flex base-width_fullscreen">
          <el-select
            v-model="form.zone"
            :placeholder="$t('customCluster.createCluster.placeholder.selectZone')"
            class="formItem__select-short base-margin__right-20"
            filterable
            @change="changeZone"
          >
            <el-option v-for="item in zones" :key="item.ZoneId" :label="item.ZoneName" :value="item.Zone"></el-option>
          </el-select>
          <el-select
            v-model="form.subnetId"
            :placeholder="$t('customCluster.createCluster.placeholder.selectSubnetInfo')"
            filterable
            @change="changeSubnet"
          >
            <el-option
              v-for="item in subnetList"
              :key="item.SubnetId"
              :label="`${item.SubnetId} | ${item.SubnetName} | ${item.CidrBlock}`"
              :value="item.SubnetId"
            ></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item :label="$t('customCluster.createCluster.form.securityGroup')" filterable prop="securityGroupIds">
        <div class="base-flex">
          <el-select v-model="form.securityGroupIds"
                     :placeholder="$t('customCluster.createCluster.placeholder.selectSecurityGroup')" filterable
                     multiple>
            <el-option
              v-for="item in securityGroupOption"
              :key="item.SecurityGroupId"
              :label="`${item.SecurityGroupId} | ${item.SecurityGroupName}`"
              :value="item.SecurityGroupId"
            ></el-option>
          </el-select>
          <div class="base-margin__left-10">
            <i
              :class="`base-color__light_blue base-font-size__16px base-cursor__pointer ${getSecurityGroupLoading ? 'el-icon-loading' : 'el-icon-refresh'}`"
              @click="getSecurityGroup"></i>
          </div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('customCluster.createCluster.form.billingMethod')"
                    prop="instanceChargeType">
        <el-select
          v-model="form.instanceChargeType"
          :placeholder="$t('customCluster.createCluster.placeholder.selectBillingMethod')"
          class="select-width"
          @change="changeBillingValue"
        >
          <el-option v-for="item in billingTypeData" :key="item.value" :label="item.text" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <div v-if="form.instanceChargeType === 'PREPAID'">
        <el-form-item :label="$t('customCluster.createCluster.form.renewalDuration')">
          <el-select v-model="form.instanceChargePrepaidPeriod"
                     :placeholder="$t('customCluster.createCluster.placeholder.selectRenewalDuration')">
            <el-option v-for="item in timeOptions" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('customCluster.createCluster.form.autoRenewal')">
          <el-checkbox v-model="form.instanceChargePrepaidRenewFlag" false-label="NOTIFY_AND_MANUAL_RENEW"
                       true-label="NOTIFY_AND_AUTO_RENEW">
            <span class="base-color__light_grey">
              {{ $t('customCluster.createCluster.tips.autoRenewal') }}
            </span>
          </el-checkbox>
        </el-form-item>
      </div>
      <el-form-item :label="$t('customCluster.createCluster.form.instanceType')" prop="instanceDescription">
        <div class="base-flex">
          <el-select
            v-model="form.instanceService"
            class="formItem__select-short base-margin__right-20"
            filterable
            @change="changeInstanceServiceType"
          >
            <el-option
              v-for="item in instanceServiceTypeOption"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="form.instanceType"
            :placeholder="$t('customCluster.createCluster.placeholder.selectInstanceType')"
            class="formItem__select-short base-margin__right-20"
            filterable
            @change="changeInstanceType"
          >
            <el-option
              v-for="item in instanceTypeOption"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
          <div class="base-flex__1">
            <el-select
              v-model="form.instanceDescription"
              :placeholder="$t('customCluster.createCluster.placeholder.selectConfiguration')"
              filterable
              @change="changeInstanceDescription"
            >
              <el-option
                v-for="item in instanceDescriptionOption"
                :key="item.value"
                :disabled="item.disabled"
                :label="item.text"
                :value="item.value"
              >
                <div class="base-flex__between base-flex__cross-center">
                  <span>{{ item.text }}</span>
                  <el-tooltip :offset="10" placement="right-end" popper-class="tooltipBox">
                    <div slot="content">
                      <p>{{ $t('customCluster.createCluster.tooltip.vCPU') }}: {{
                          item.Cpu || '-'
                        }}{{ $t('customCluster.createCluster.tooltip.core') }}</p>
                      <p>{{ $t('customCluster.createCluster.tooltip.memory') }}: {{ item.Memory || '-' }}GiB</p>
                      <p>{{ $t('customCluster.createCluster.tooltip.processorFrequency') }}: {{
                          item.Frequency || '-'
                        }}</p>
                      <p>{{ $t('customCluster.createCluster.tooltip.processorModel') }}: {{ item.CpuType || '-' }}</p>
                      <p>{{ $t('customCluster.createCluster.tooltip.internalBandwidth') }}:
                        {{ item.InstanceBandwidth || '-' }}Gbps</p>
                      <p>{{ $t('customCluster.createCluster.tooltip.networkPackets') }}: {{
                          item.InstancePps || '-'
                        }}{{ $t('customCluster.createCluster.tooltip.tenThousandPPS') }}</p>
                    </div>
                    <i class="el-icon-warning-outline"></i>
                  </el-tooltip>
                </div>
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('customCluster.createCluster.form.systemDisk')" prop="diskType">
        <el-select
          v-model="form.diskType"
          :placeholder="$t('customCluster.createCluster.placeholder.selectSystemDisk')"
          class="formItem__select-short base-margin__right-20"
          @change="changeDisk"
        >
          <el-option v-for="item in diskList" :key="item.key" :label="`${item.key} | ${item.remark}`"
                     :value="item.value"></el-option>
        </el-select>
        <el-input-number
          v-model="form.diskSize"
          :min="gibMinNumber"
          class="formItem__select-short"
          @change="changeDiskSize()"
        ></el-input-number>
        GIB
      </el-form-item>
      <el-form-item v-if="!isEditCluster" :label="$t('customCluster.createCluster.form.hyperThreading')">
        <el-checkbox v-model="form.topology" :disabled="notTopology">
          {{ $t('customCluster.createCluster.checkbox.enableHyperThreading') }}
        </el-checkbox>
      </el-form-item>
      <el-form-item label-width="120px" label="高性能计算集群" prop="hpcClusterId">
        <el-select
          v-model="form.hpcClusterId"
          :placeholder="$t('customCluster.createCluster.placeholder.selectInstanceType')"
          class="formItem__select-short base-margin__right-20"
          clearable
        >
          <el-option
            v-for="item in hpcClustersList"
            :key="item.HpcClusterId"
            :label="`${item.HpcClusterId} | ${item.Name} | 已用${item.CurrentNum}(容量${item.CvmQuotaTotal})`"
            :value="item.HpcClusterId"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <el-table
      v-if="clusterActive === 1"
      :key="JSON.stringify(hostRangeListForm)"
      :data="hostRangeListForm"
      style="width: 100%">
      <el-table-column
        :label="$t('customCluster.createCluster.table.hostnamePrefix')"
      >
        <template slot-scope="scope">
          <span>
             {{ scope.row.hostnamePattern }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('customCluster.createCluster.table.startIp')"
      >
        <template slot-scope="scope">
          {{ formatIp(scope.row.startIp) }}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('customCluster.createCluster.table.endIp')">
        <template slot-scope="scope">
          {{ formatIp(scope.row.endIp) }}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('customCluster.createCluster.table.startNumber')"
        prop="indexStart">
      </el-table-column>
      <el-table-column
        :label="$t('customCluster.createCluster.table.numberDigits')"
        prop="indexLength">
      </el-table-column>
      <el-table-column
        :label="$t('customCluster.createCluster.table.operation')"
        fixed="right"
        width="100">
        <template slot-scope="scope">
          <el-button size="small" type="text" @click="editHostRangeList(scope.$index, scope.row)">
            {{ $t('customCluster.createCluster.button.edit') }}
          </el-button>
          <el-button size="small" type="text" @click="deleteHostRangeList(scope.$index)">
            {{ $t('customCluster.createCluster.button.delete') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="clusterActive === 1" class="base-text-align__right base-margin__right-20">
      <el-button class="base-marginTop__10" type="text" @click="addIpRange">
        {{ $t('customCluster.createCluster.button.addIpRange') }}
      </el-button>
    </div>

    <el-table v-if="clusterActive === 2" :data="previewList" class="base-width_fullscreen" height="500">
      <el-table-column :label="$t('customCluster.createCluster.table.hostname')" prop="hostname"></el-table-column>
      <el-table-column :label="$t('customCluster.createCluster.table.ip')" prop="ip"></el-table-column>
    </el-table>

    <div v-if="clusterActive === 3">
      <div class="base-flex">
        <el-input
          v-model="userDataScript"
          :placeholder="$t('customCluster.customList.initScriptPlaceholder')"
          :rows="20"
          type="textarea"
        >
        </el-input>

        <div class="base-margin__left-8">
          <el-input
            :placeholder="$t('customCluster.customList.searchPlaceholder')"
            class="base-margin__bottom-5"
            clearable
          >
          </el-input>
          <div class="userDataTemplate-cls">
            <div
              v-for="(item, index) in userdataTemplateList"
              :key="index"
              class="base-flex__between"
              @click="checkUserDataScript(item)"
            >
              <div>
                <i class="el-icon-tickets"/> <span>{{ item.name }}</span>
              </div>
              <el-tooltip :content="item.tips" class="item" effect="dark" placement="left-start">
                <div><i class="el-icon-warning-outline"/></div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <p class="base-margin__top-5">
        <el-checkbox v-model="base64Radio">{{ $t('customCluster.customList.base64Encoded') }}</el-checkbox>
      </p>
    </div>

    <!--添加 ip端-->
    <el-dialog
      :close-on-click-modal="false"
      :title="`${$t('customCluster.createCluster.dialog.ipRange')} ${form.subnetCidrBlock}`"
      :visible.sync="hostRangeListVisible"
      append-to-body
      width="750px"
    >
      <div>
        <el-form ref="hostRangeListForm" label-width="90px">
          <div>
            <div class="ipBox">
              <div class="base-flex base-position__relative startIp_input">
                <span>{{ $t('customCluster.createCluster.label.startIp') }}</span>
                <el-input v-for="(item, ipStartIndex) in showHostRangeListForm.startIp" :key="ipStartIndex + 10"
                          v-model="item.value" :disabled="item.disabled" type="number">
                </el-input>
                <span>{{ $t('customCluster.createCluster.label.endIp') }}</span>
                <el-input v-for="(item, ipEndIndex) in showHostRangeListForm.endIp" :key="ipEndIndex + 100"
                          v-model="item.value" :disabled="item.disabled" type="number">
                </el-input>
              </div>
              <div class="tips_cls">{{ $t('customCluster.createCluster.tips.reservedIps') }}</div>
              <div class="base-flex base-position__relative startIp_input">
                <span>{{ $t('customCluster.createCluster.label.hostnamePrefix') }}</span>
                <el-input v-model="showHostRangeListForm.hostnamePattern"
                          :placeholder="$t('customCluster.createCluster.placeholder.enterHostname')"
                          class="div-width__180"></el-input>
                <span>{{ $t('customCluster.createCluster.label.startNumber') }}</span>
                <el-input v-model="showHostRangeListForm.indexStart" type="number"></el-input>
                <span>{{ $t('customCluster.createCluster.label.numberDigits') }}</span>
                <el-input v-model="showHostRangeListForm.indexLength" type="number"></el-input>
                <div class="preview_div--button base-cursor__pointer base-color__light_blue" @click="preview">
                  {{ $t('customCluster.createCluster.button.preview') }}
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button @click="closeHostList">{{ $t('customCluster.createCluster.button.cancel') }}</el-button>
            <el-button type="primary" @click="doneEditHostRangeList">{{
                $t('customCluster.createCluster.button.confirm')
              }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getRequest, postRequest } from '@/common/libs/request';
import { mapGetters, mapState } from 'vuex';
import { Message } from 'element-ui';
import { Base64 } from 'js-base64';
// import {Base64} from "js-base64";

export default {
  name: 'createCluster',
  props: {
    closeDialog: Function, // 关闭弹窗
    getSubclusterList: Function,
    openPwDialog: Function,
    hostRangeListFormEmit: Function,
    checkPrice: {
      type: Function,
      default: () => {
      },
    },
  },
  data() {
    return {
      clusterActive: 0,
      hostRangeListVisible: false,
      showHostRangeListForm: [],
      hostRangeListForm: [],
      defaultHostRangeListForm: [],
      hostRangeList: [],
      hostRangeListIndex: 0,
      hostRangeListType: 'add',
      previewList: [],
      hostRangeListFormIndex: false,
      info: [],
      isEditCluster: false,
      clusterId: 0,
      previewDialogVisible: false,
      aLink: '',
      projectId: '',
      currentProject: '',
      regionList: [],
      vpcList: [],
      securityGroupOption: [],
      subnetList: [],
      zones: [],
      imageList: [],
      diskList: [],
      instanceTypeOption: [],
      instanceServiceTypeOption: [
        { value: 'cvm', text: 'CVM' },
        { value: 'thpc', text: 'THPC' },
      ],
      instanceServiceList: [],
      instanceDescriptionOption: [],
      hpcClustersList: [],
      imageSize: 0,
      notTopology: false,
      form: {
        name: '',
        region: '',
        vpcId: '',
        imageType: '',
        imageId: '',
        diskType: '',
        diskSize: 0,
        instanceType: '',
        instanceDescription: '',
        securityGroupIds: [],
        subnetId: '',
        zone: '',
        topology: false,
        platform: '',
        clusterType: '',
        instanceChargeType: 'POSTPAID_BY_HOUR', // 计费方式
        instanceChargePrepaidPeriod: 1,
        instanceChargePrepaidRenewFlag: 'NOTIFY_AND_MANUAL_RENEW',
        subnetCidrBlock: '',
        instanceService: 'cvm',
        thpcInstanceTypePrice: '0',
        hpcClusterId: '',
      },
      billingTypeData: [
        // 计费方式选择
        { value: 'POSTPAID_BY_HOUR', text: this.$t('customCluster.createCluster.billingType.hourly') },
        { value: 'PREPAID', text: this.$t('customCluster.createCluster.billingType.monthly') },
        // { value: 'SPOTPAID', text: this.$t('customCluster.createCluster.bidding') },
      ],
      createClusterRules: {
        name: [{ required: true, message: this.$t('customCluster.createCluster.rules.name'), trigger: 'change' }],
        region: [{ required: true, message: this.$t('customCluster.createCluster.rules.region'), trigger: 'change' }],
        vpcId: [{ required: true, message: this.$t('customCluster.createCluster.rules.vpc'), trigger: 'change' }],
        imageType: [{
          required: true,
          message: this.$t('customCluster.createCluster.rules.imageType'),
          trigger: 'change',
        }],
        imageId: [{ required: true, message: this.$t('customCluster.createCluster.rules.image'), trigger: 'change' }],
        diskType: [{ required: true, message: this.$t('customCluster.createCluster.rules.diskType'), trigger: 'change' }],
        diskSize: [{ required: true, message: this.$t('customCluster.createCluster.rules.diskSize'), trigger: 'change' }],
        instanceType: [{
          required: true,
          message: this.$t('customCluster.createCluster.rules.instanceType'),
          trigger: 'change',
        }],
        instanceDescription: [{
          required: true,
          message: this.$t('customCluster.createCluster.rules.instanceConfig'),
          trigger: 'change',
        }],
        securityGroupIds: [{
          required: true,
          message: this.$t('customCluster.createCluster.rules.securityGroup'),
          trigger: 'change',
        }],
        zone: [{ required: true, message: this.$t('customCluster.createCluster.rules.zone'), trigger: 'change' }],
        subnetId: [{ required: true, message: this.$t('customCluster.createCluster.rules.subnet'), trigger: 'change' }],
      },
      // editInstanceTypeReset: false,
      gibMinNumber: 1,
      newFields: {}, // 新字段
      getSecurityGroupLoading: false,
      getVpcListLoading: false,
      createClusterLoading: false,
      timeOptions: [
        // 购买时长选择
        { text: this.$t('customCluster.createCluster.duration.oneMonth'), value: 1 },
        { text: this.$t('customCluster.createCluster.duration.twoMonths'), value: 2 },
        { text: this.$t('customCluster.createCluster.duration.threeMonths'), value: 3 },
        { text: this.$t('customCluster.createCluster.duration.fourMonths'), value: 4 },
        { text: this.$t('customCluster.createCluster.duration.fiveMonths'), value: 5 },
        { text: this.$t('customCluster.createCluster.duration.sixMonths'), value: 6 },
        { text: this.$t('customCluster.createCluster.duration.sevenMonths'), value: 7 },
        { text: this.$t('customCluster.createCluster.duration.eightMonths'), value: 8 },
        { text: this.$t('customCluster.createCluster.duration.nineMonths'), value: 9 },
        { text: this.$t('customCluster.createCluster.duration.tenMonths'), value: 10 },
        { text: this.$t('customCluster.createCluster.duration.elevenMonths'), value: 11 },
        { text: this.$t('customCluster.createCluster.duration.oneYear'), value: 12 },
        { text: this.$t('customCluster.createCluster.duration.twoYears'), value: 24 },
        { text: this.$t('customCluster.createCluster.duration.threeYears'), value: 36 },
        { text: this.$t('customCluster.createCluster.duration.fourYears'), value: 48 },
        { text: this.$t('customCluster.createCluster.duration.fiveYears'), value: 60 },
      ],
      imageTypeList: [],
      imageOptionList: [],
      imagePlatformType: '',
      userdataTemplateList: [],
      base64Radio: false,
      userDataScript: '',
    };
  },
  watch: {
    'app.currentProject'(val) {
      const currentProject = this.getCurrentProject();
      if (currentProject.id !== this.projectId) {
        this.projectId = val.id;
      }
    },
  },
  methods: {
    // 检测用户数据
    checkUserDataScript(item) {
      this.userDataScript = item.content;
    },

    // 删除IP段
    deleteHostRangeList(index) {
      this.hostRangeListForm.splice(index, 1);
      this.$emit('hostRangeListFormEmit', this.hostRangeListForm);
    },


    // 编辑IP段
    editHostRangeList(index, item) {
      this.hostRangeListType = 'edit';
      this.showHostRangeListForm = JSON.parse(JSON.stringify(item));
      this.hostRangeListVisible = true;
      this.hostRangeListIndex = index;
    },

    // 完成编辑IP段
    doneEditHostRangeList() {
      if (this.hostRangeListType === 'edit') {
        this.hostRangeListForm[this.hostRangeListIndex] = this.showHostRangeListForm;
      } else {
        if (this.clusterType === 'create' && !this.hostRangeListFormIndex) {
          this.hostRangeListFormIndex = true;
          this.hostRangeListForm[0] = this.showHostRangeListForm;
        } else {
          this.hostRangeListForm.push(this.showHostRangeListForm);
        }
      }
      this.$emit('hostRangeListFormEmit', this.hostRangeListForm);
      this.hostRangeListVisible = false;
    },


    /**
     * 将IP地址字符串转换成数字，方便递增计算
     * 例如 "172.16.0.1" => 数字形式
     * @param {string} ip - 点分十进制IP地址
     * @returns {number} - 转换后的数字
     */
    ipToNumber(ip) {
      return ip.split('.').reduce((acc, octet) => (acc << 8) + Number(octet), 0);
    },

    /**
     * 将数字转换回IP地址字符串
     * 例如 数字 => "172.16.0.1"
     * @param {number} num - IP的数字形式
     * @returns {string} - 点分十进制IP地址
     */
    numberToIp(num) {
      return [
        (num >> 24) & 0xff,
        (num >> 16) & 0xff,
        (num >> 8) & 0xff,
        num & 0xff,
      ].join('.');
    },


    /**
     * 将数字转换成固定长度字符串，前面补0
     * 例如 padNumber(5, 3) => "005"
     * @param {number} num - 需要格式化的数字
     * @param {number} length - 固定长度
     * @returns {string} - 补0后的字符串
     */
    padNumber(num, length) {
      return num.toString().padStart(length, '0');
    },

    /**
     * 根据起始IP和结束IP生成IP数组，每个元素包含ip和hostname
     * hostname = hostnamePattern + 固定长度补0的index
     * @param {Object} params
     * @param {string} params.startIp - 起始IP地址
     * @param {string} params.endIp - 结束IP地址
     * @param {string} params.hostnamePattern - 主机名前缀
     * @param {number} params.indexLength - index长度，hostname中index部分固定宽度
     * @param {number} params.indexStart - index起始值
     * @returns {Array} - 生成的数组，每个元素格式：{ ip: string, hostname: string }
     */
    generateIpArray({ startIp, endIp, hostnamePattern, indexLength, indexStart }) {
      const startNum = this.ipToNumber(startIp); // 起始IP数字
      const endNum = this.ipToNumber(endIp);  // 结束IP数字
      const result = [];
      let index = indexStart;

      // 从起始IP数字递增到结束IP数字，生成IP数组
      for (let ipNum = startNum; ipNum <= endNum; ipNum++) {
        const ipStr = this.numberToIp(ipNum);
        const fourthOctet = Number(ipStr.split('.')[3]);

        // 如果第四段是0,1,255，跳过该IP，不加入结果，但index依然递增
        if (fourthOctet === 0 || fourthOctet === 1 || fourthOctet === 255) {
          continue;
        }

        result.push({
          ip: this.numberToIp(ipNum), // 当前IP字符串
          hostname: hostnamePattern + this.padNumber(index, indexLength), // 拼接hostname
        });
        // eslint-disable-next-line no-plusplus
        index++;
      }

      return result;
    },


    /**
     * 下一步 上一步
     * 根据当前步骤，显示对应的表单
     */
    createHostRangeList(index) {
      return new Promise((resolve, reject) => {
        this.clusterActive = index;
        const ipRangeList = this.hostRangeListFormDone();
        if (index === 2) {
          if (ipRangeList) {
            postRequest('/api/eda/common/subcluster/getHostnamePreview', {
              subnetCidr: this.form.subnetCidrBlock,
              hostRangeList: ipRangeList,
            }).then((res) => {
              resolve();
              this.previewList = res.relationList || [];
              const defaultConfig = '#!/bin/bash\necho -e "((hosts))" >> /etc/hosts';
              const regex = new RegExp('\\(\\(hosts\\)\\)', 'g');
              const configTemplate = res.relationList.map(item => `${item.ip} ${item.hostname}`).join('\n');
              const baseValue = defaultConfig.replace(regex, configTemplate);
              this.userdataTemplateList = [{
                name: 'config /etc/hosts',
                content: baseValue,
                tips: '将子集群的hostname映射关系导入到/etc/hosts中',
              }];
              console.log(this.userdataTemplateList, 'userdataTemplateList');
            })
              .catch(() => {
                this.clusterActive = index - 1;
                this.previewList = [];
                reject(false);
              });
          } else {
            this.clusterActive = index - 1;
            this.previewList = [];
            reject(false);
          }
        }
      });
    },

    /**
     * 添加IP段
     */
    addIpRange() {
      this.hostRangeListType = 'add';
      this.hostRangeListVisible = true;
      this.showHostRangeListForm = JSON.parse(JSON.stringify(this.defaultHostRangeListForm));
    },

    // 取消添加IP
    closeHostList() {
      this.hostRangeListVisible = false;
    },

    // 格式化IP
    formatIp(item) {
      return item.map(ipPart => ipPart.value).join('.');
    },

    /**
     * 处理主机范围列表表单提交
     * 验证各项输入并格式化数据
     */
    hostRangeListFormDone() {
      try {
        // 主机名正则：字母开头，可包含字母数字、点号和连字符
        const hostNameReg = /^[a-zA-Z][a-zA-Z0-9]*([.-][a-zA-Z0-9]+)*([.-]?)$/;
        // 编号位数正则：正整数
        const indexPatternReg = /^[1-9]\d*$/;

        let hasError = false; // 标记是否有验证错误

        const ipList = this.hostRangeListForm.map((item, index) => {
          const indexNumber = index + 1; // 用户可见的序号(从1开始)
          const startIp = item.startIp.map(ipPart => ipPart.value).join('.');
          const endIp = item.endIp.map(ipPart => ipPart.value).join('.');

          // 验证编号位数
          if (!item.indexLength) {
            this.$message.error(this.$t('customCluster.createCluster.validation.enterIndexLength', { index: indexNumber }));
            hasError = true;
            return null;
          }
          if (!indexPatternReg.test(item.indexLength)) {
            this.$message.error(this.$t('customCluster.createCluster.validation.invalidIndexLength', { index: indexNumber }));
            hasError = true;
            return null;
          }

          // 验证主机名
          if (!item.hostnamePattern) {
            this.$message.error(this.$t('customCluster.createCluster.validation.enterHostname', { index: indexNumber }));
            hasError = true;
            return null;
          }
          if (item.hostnamePattern.length >= 60 - Number(item.indexLength)) {
            this.$message.error(this.$t('customCluster.createCluster.validation.hostnameTooLong', { index: indexNumber }));
            hasError = true;
            return null;
          }
          if (!hostNameReg.test(item.hostnamePattern)) {
            this.$message.error(this.$t('customCluster.createCluster.validation.invalidHostname', { index: indexNumber }));
            hasError = true;
            return null;
          }
          // indexStart 和 indexLength 可以为0

          if (!item.indexStart) {
            this.$message.error(this.$t('customCluster.createCluster.validation.enterStartNumber', { index: indexNumber }));
            hasError = true;
            return null;
          }

          if (item.indexStart === 0) {
            this.$message.error(this.$t('customCluster.createCluster.validation.startNumberCannotBeZero', { index: indexNumber }));
            hasError = true;
            return null;
          }

          if (!item.indexLength) {
            this.$message.error(this.$t('customCluster.createCluster.validation.enterIndexLength', { index: indexNumber }));
            hasError = true;
            return null;
          }

          if (item.indexLength === 0) {
            if (endIp !== startIp) {
              this.$message.error(this.$t('customCluster.createCluster.validation.indexLengthCannotBeZero', { index: indexNumber }));
              hasError = true;
              return null;
            }
          }

          // 返回格式化后的有效数据
          return {
            ...item,
            indexStart: Number(item.indexStart),
            indexLength: Number(item.indexLength),
            endIp,
            startIp,
          };
        }).filter(Boolean); // 过滤掉验证失败的null项

        // 如果有任何验证错误，不继续执行
        if (hasError) {
          return false;
        }

        return ipList;
        // 所有验证通过，更新数据并触发事件
        // this.hostRangeList = ipList;
        // this.$emit('doneFillIp');
      } catch (e) {
        console.error(this.$t('customCluster.createCluster.validation.processError'), e);
        this.$message.error(this.$t('customCluster.createCluster.validation.processError'));
      }
    },

    /**
     * 复制集群时
     * 分析ip范围
     * 重新解析ip范围，并更新表单数据
     * */
    analysisIpRange(list, cidr) {
      const cidrList = cidr.split('.');
      const maskLength = Number(cidrList[3].substring(cidrList[3].indexOf('/') + 1));

      // 根据掩码长度计算需要禁用的IP段数量
      const getDisabledCount = (mask) => {
        if (mask < 16) return 1;
        if (mask < 24) return 2;
        return 3;
      };
      const disabledCount = getDisabledCount(maskLength);

      const ipList = list.map((item) => {
        // 处理IP段的通用函数
        const processIp = ip => ip.split('.').map((part, index) => ({
          value: part,
          disabled: index < disabledCount,  // 根据需要禁用的数量设置状态
        }));

        item.startIp = processIp(item.startIp);
        item.endIp = processIp(item.endIp);
        return item;
      });

      this.hostRangeListForm = ipList;
      this.$emit('hostRangeListFormEmit', this.hostRangeListForm);
    },


    /**
     * 关闭创建节点弹窗
     */
    closeForm() {
      this.hostRangeListVisible = false;
      this.clusterActive = 0;
      this.imagePlatformType = '';
      // 清除表单数据
      this.form = {
        name: '',
        region: '',
        vpcId: '',
        imageType: '',
        imageId: '',
        diskType: '',
        diskSize: 0,
        instanceType: '',
        instanceDescription: '',
        securityGroupIds: [],
        subnetId: '',
        zone: '',
        subnetCidrBlock: '',
        topology: false,
        instanceChargeType: 'POSTPAID_BY_HOUR', // 计费方式
        instanceChargePrepaidPeriod: 1,
        instanceChargePrepaidRenewFlag: 'NOTIFY_AND_MANUAL_RENEW',
        instanceService: 'cvm',
        hpcClusterId: '',
      };
      this.base64Radio = false;
      this.userDataScript = '';
      this.notTopology = false;
      this.regionList = [];
      this.vpcList = [];
      this.securityGroupOption = [];
      this.subnetList = [];
      this.zones = [];
      this.imageList = [];
      this.diskList = [];
      this.instanceTypeOption = [];
      this.instanceDescriptionOption = [];
      this.closeDialog();
      this.hostRangeListForm = [{
        startIp: [
          { value: '', disabled: true },
          { value: '', disabled: false },
          { value: '', disabled: false },
          { value: '' },
        ],
        endIp: [
          { value: '', disabled: true },
          { value: '', disabled: false },
          { value: '', disabled: false },
          { value: '' },
        ],
        hostnamePattern: '',
        indexStart: '',
        indexLength: '',
      }];
      this.$refs.form.clearValidate();
    },

    /**
     * 获取地区
     */
    getRegions() {
      this.regionList = [];
      getRequest(`/api/eda/common/tencentcloud/describeRegions?projectId=${this.projectId}`).then((res) => {
        this.regionList = res.regionSet;
      });
    },

    changeIsEditCluster() {
      this.isEditCluster = false;
      this.clusterType = 'create';
    },

    // 编辑 获取实例详情信息
    editCluster(id, type) {
      this.getSubclusterDetail(id);
      this.clusterId = id;
      this.isEditCluster = type === 'edit';
      this.clusterType = type;
    },

    // 编辑 获取实例详情信息
    async getSubclusterDetail(id) {
      const data = {
        subclusterId: id,
      };
      await postRequest('/api/eda/common/subcluster/getSubclusterDetail', data).then((res) => {
        this.info = res.subclusterDetail;
        const data = this.info;
        this.analysisIpRange(data.hostRangeList, data.subnetCidr);
        this.form = Object.assign(this.form, data);

        this.form.subnetCidrBlock = data.subnetCidr;
        this.form.topology = data.hyperTreading;
        this.form.instanceChargeType = data.instanceChargeType;
        this.form.instanceChargePrepaidPeriod = data.instanceChargePrepaidPeriod || 1;
        this.form.instanceChargePrepaidRenewFlag = data.instanceChargePrepaidRenewFlag || 'NOTIFY_AND_MANUAL_RENEW';
        // this.userDataScript = data.userData || '';
        this.getRegions();
        this.getZones();
        this.getImages();
        this.getInstanceTypeList();
        this.getDescribeHpcClusters();
        this.getDisk();
        // 获取vpclist
        const { instanceType } = this.form;
        this.form.instanceType = '';
        this.form.instanceDescription = instanceType || '';
        this.getVpcList();
        this.getSecurityGroup();
        this.getSubnet();
        this.getSubclusterCommand();
      });
    },

    // 编辑 获取初始化命令
    getSubclusterCommand() {
      postRequest('api/eda/common/subcluster/getSubclusterInitCommand', {
        subclusterId: this.clusterId,
      }).then((res) => {
        this.userDataScript = Base64.decode(res.userData) || '';
        // this.initCommand = res.initCommand;
      });
    },

    /**
     * 获取地域
     */
    getZones() {
      this.zones = [];
      postRequest('/api/eda/common/tencentcloud/describeZones', {
        projectId: this.projectId,
        region: this.form.region,
      }).then((res) => {
        this.zones = res.zoneSet;
      });
    },

    /**
     * 获取vpc列表
     */
    getVpcList() {
      this.vpcList = [];
      this.getVpcListLoading = true;
      if (this.form.region === '') {
        this.getVpcListLoading = false;
        return;
      }
      getRequest(`/api/eda/common/tencentcloud/describeVpcList?region=${this.form.region}`).then((res) => {
        this.vpcList = res.vpcSet;
        this.getVpcListLoading = false;
      })
        .catch(() => {
          this.getVpcListLoading = false;
        });
    },

    /**
     * 获取安全组
     */
    getSecurityGroup() {
      this.securityGroupOption = [];
      this.getSecurityGroupLoading = true;
      postRequest('/api/eda/common/tencentcloud/describeSecurityGroupList', {
        region: this.form.region,
      }).then((res) => {
        this.getSecurityGroupLoading = false;
        this.securityGroupOption = res.securityGroup;
      })
        .catch(() => {
          this.getSecurityGroupLoading = false;
        });
    },

    /**
     * 获取子网信息
     */
    getSubnet() {
      this.subnetList = [];
      if (this.form.vpcId === '') {
        return;
      }
      if (this.form.zone === '') {
        return;
      }
      postRequest('/api/eda/common/tencentcloud/describeSubnetList', {
        projectId: this.projectId,
        region: this.form.region,
        vpcId: this.form.vpcId,
        zone: this.form.zone,
      }).then((res) => {
        this.subnetList = res.subnetSet;
        if (res.totalCount > 0) {
          this.changeSubnet(this.info.subnetId);
        } else {
          console.log('该VPC下没有子网信息，请重新选择VPC', this.isEditCluster);
          if (this.isEditCluster) {
            this.$message.warning('当前子集群没有子网信息，请重新创建子集群或者复制子集群重新选择VPC!');
          } else {
            this.$message.warning('该VPC下没有子网信息，请重新选择VPC');
          }
          this.form.subnetId = '';
        }
      });
    },

    /**
     * 编辑子集群
     */
    modify(resolve, reject) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          postRequest('/api/eda/common/subcluster/modifySubclusterConfig', {
            SubclusterId: this.clusterId,
            Name: this.form.name,
            ImageId: this.form.imageId,
            InstanceType: this.form.instanceDescription,
            ImageType: this.form.imageType,
            DiskType: this.form.diskType,
            SecurityGroupIds: this.form.securityGroupIds,
            DiskSize: this.form.diskSize,
            InstanceChargeType: this.form.instanceChargeType,
            InstanceChargePrepaidPeriod: this.form.instanceChargePrepaidPeriod,
            InstanceChargePrepaidRenewFlag: this.form.instanceChargePrepaidRenewFlag,
            InstanceService: this.form.instanceService,
            HpcClusterId: this.form.hpcClusterId,
            ...this.newFields,
          })
            .then(() => {
              this.$message.success(this.$t('customCluster.createCluster.success.modify'));
              this.closeDialog();
              this.getSubclusterList('edit');
              resolve();
            })
            .catch(() => reject());
        } else {
          return reject();
        }
      });
    },

    /**
     * 创建子集群
     */
    createSubcluster(resolve, reject) {
      if (this.isEditCluster) {
        this.modify(resolve, reject);
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          const createForm = Object.assign({ projectId: this.projectId }, this.form, this.newFields);
          createForm.instanceType = this.form.instanceDescription;
          createForm.topology = this.form.topology;
          createForm.hostRangeList = this.hostRangeListFormDone();
          createForm.instanceChargeType = this.form.instanceChargeType;
          createForm.userData = this.base64Radio ? this.userDataScript : Base64.encode(this.userDataScript);

          postRequest('/api/eda/common/subcluster/createSubcluster', createForm)
            .then(() => {
              Message.success(this.$t('customCluster.createCluster.success.create'));
              this.closeDialog();
              this.getSubclusterList();
              resolve();
            })
            .catch(() => {
              reject();
            });
        } else {
          reject();
        }
      });
    },

    /**
     * 创建 or 编辑 子集群
     */
    clickAccomplish() {
      return new Promise((resolve, reject) => {
        this.createSubcluster(resolve, reject);
      });
    },

    /**
     * 获取机型列表
     */
    getInstanceTypeList() {
      this.createClusterLoading = true;
      if (this.form.instanceService === 'thpc') {
        getRequest(`https://eda-static-cdn-1300241787.file.myqcloud.com/build/api/public/thpcSellInstanceTypeList.json?t=${new Date().getTime()}`).then((res) => {
          this.disposeInstanceTypeList(res);
          this.instanceServiceList = res || [];
        });
      } else {
        postRequest('/api/eda/common/tencentcloud/describeZoneSellInstanceTypeList', {
          projectId: this.projectId,
          region: this.form.region,
          zone: this.form.zone,
          platform: this.form.platform,
        }).then((res) => {
          this.disposeInstanceTypeList(res.instanceTypeSet);
        });
      }
    },

    /**
     * 处理机型列表
     */
    disposeInstanceTypeList(instanceTypeSet) {
      console.log(123, '123123111');
      const cvmMapPostpaidByHour = new Map();
      const cvmMapPrepaid = new Map();
      const cvmMapBidding = new Map();

      // 根据机型去重
      const cvmNonredundantPostpaidByHourMap = new Map();
      const cvmNonredundantPrepaidMap = new Map();
      const cvmBiddingInstanceMap = new Map();
      instanceTypeSet.forEach((cvm) => {
        if (cvm.InstanceChargeType === 'POSTPAID_BY_HOUR') {
          cvmNonredundantPostpaidByHourMap.set(cvm.InstanceType, cvm);
        }
        if (cvm.InstanceChargeType === 'PREPAID') {
          cvmNonredundantPrepaidMap.set(cvm.InstanceType, cvm);
        }
        if (cvm.InstanceChargeType === 'SPOTPAID') {
          cvmBiddingInstanceMap.set(cvm.InstanceType, cvm);
        }
      });
      // 构造按量计费结构
      for (const cvm of cvmNonredundantPostpaidByHourMap.values()) {
        if (cvmMapPostpaidByHour.has(cvm.TypeName)) {
          cvmMapPostpaidByHour.get(cvm.TypeName).push(cvm);
        } else {
          cvmMapPostpaidByHour.set(cvm.TypeName, [cvm]);
        }
      }

      // 构造包年包月结构
      for (const cvm of cvmNonredundantPrepaidMap.values()) {
        if (cvmMapPrepaid.has(cvm.TypeName)) {
          cvmMapPrepaid.get(cvm.TypeName).push(cvm);
        } else {
          cvmMapPrepaid.set(cvm.TypeName, [cvm]);
        }
      }

      // 构造竞价实例结构
      for (const cvm of cvmBiddingInstanceMap.values()) {
        if (cvmMapBidding.has(cvm.TypeName)) {
          cvmMapBidding.get(cvm.TypeName).push(cvm);
        } else {
          cvmMapBidding.set(cvm.TypeName, [cvm]);
        }
      }
      this.allCvmsData = [cvmMapPostpaidByHour, cvmMapPrepaid, cvmMapBidding];
      const instanceTypeList = [];
      this.selectBilling().forEach((item, key) => {
        const instanceTypeNameList = item.map(item => item.InstanceType);

        const typeOption = {
          value: key,
          text: key,
          instanceTypeNameList,
        };
        instanceTypeList.push(typeOption);
      });

      this.createClusterLoading = false;
      this.instanceTypeOption = instanceTypeList;
      if (this.clusterType !== 'create') {
        const instanceType = this.form.instanceDescription;
        let text = '';
        this.instanceTypeOption.forEach((item) => {
          if (item.instanceTypeNameList.indexOf(instanceType) !== -1) {
            this.form.instanceType = item.text;
            text = item.text;
          }
        });
        console.log(text, 'text');
        if (text === '') return;
        this.changeInstanceType(text, true);
      }
    },

    /**
     * 选择计费方式
     */
    changeBillingValue() {
      this.form.instanceType = '';
      this.form.instanceDescription = '';
      const instanceTypeList = [];
      this.selectBilling().forEach((item, key) => {
        const instanceTypeNameList = item.map(item => item.InstanceType);

        const typeOption = {
          value: key,
          text: key,
          instanceTypeNameList,
        };
        instanceTypeList.push(typeOption);
      });

      this.instanceTypeOption = instanceTypeList;
    },


    /**
     * 筛选计费方式机型
     */
    selectBilling() {
      if (!this.allCvmsData) return [];
      let cvmsDataMap = new Map();
      if (this.form.instanceChargeType === 'POSTPAID_BY_HOUR') {
        [cvmsDataMap] = this.allCvmsData;
      }
      if (this.form.instanceChargeType === 'PREPAID') {
        [, cvmsDataMap] = this.allCvmsData;
      }
      if (this.form.instanceChargeType === 'SPOTPAID') {
        [, , cvmsDataMap] = this.allCvmsData;
      }
      return cvmsDataMap;
    },

    /**
     * 选择机型
     */
    changeInstanceType(text, editType) {
      if (!editType) this.form.instanceDescription = '';
      const instanceDescriptionList = [];
      this.selectBilling().get(text)
        .forEach((cvm) => {
          // 填充描述信息
          let description = `${cvm.Cpu}${this.$t('customCluster.createCluster.core')} ${cvm.Memory}GB ${cvm.Remark} | ${cvm.InstanceType}`;
          let disabled = false;
          if (cvm.Status === 'SOLD_OUT') {
            description = `${description}(${this.$t('customCluster.createCluster.soldOut')})`;
            disabled = true;
          }
          // if (cvm.Gpu > 0) {
          //   description += `，${cvm.Gpu}颗${cvm.InstanceFamily} GPU`;
          // }
          const descriptionOption = {
            value: cvm.InstanceType,
            text: description,
            disabled,
            InstanceFamily: cvm.InstanceFamily,
            Cpu: cvm.Cpu,
            // 处理器型号
            CpuType: cvm.CpuType,
            Gpu: cvm.Gpu,
            Memory: cvm.Memory,
            // 主频
            Frequency: cvm.Frequency,
            // 带宽
            InstanceBandwidth: cvm.InstanceBandwidth,
            // 网卡
            NetworkCard: cvm.NetworkCard,
            InstancePps: cvm.InstancePps,
            Price: cvm.Price,
          };
          instanceDescriptionList.push(descriptionOption);
        });
      this.instanceDescriptionOption = instanceDescriptionList;
      this.getDisk(instanceDescriptionList[0].InstanceFamily);
    },


    /**
     * 切换服务
     */
    changeInstanceServiceType() {
      // if (this.isEditCluster)
      this.form.instanceType = '';
      this.form.instanceDescription = '';
      this.form.hpcClusterId = '';
      this.getInstanceTypeList();
    },

    /**
     * 获取系统盘
     */
    getDisk(instanceFamily) {
      this.diskList = [];
      postRequest('/api/eda/common/tencentcloud/describeDiskType', {
        projectId: this.projectId,
        region: this.form.region,
        zone: this.form.zone,
        cvmInstanceFamily: [instanceFamily],
      }).then((res) => {
        if (res.diskTypeSet == null || res.diskTypeSet.length === 0) {
          return this.$message.error(this.$t('customCluster.createCluster.error.noDiskAvailable'));
        }
        this.diskList = res.diskTypeSet;
        const newArr = [];
        this.diskList.forEach((item) => {
          const newObj = {
            key: this.handleCbs(item.disk_type),
            value: item.disk_type,
            minSize: item.disk_size.min_size,
            remark: item.overall_performance || '',
          };
          newArr.push(newObj);
        });
        this.diskList = newArr;
        if (this.form.diskType !== '' && !this.isEditCluster) {
          this.checkPrice(this.form);
        }
      });
    },

    handleCbs(diskType) {
      let label = '';
      switch (diskType) {
        case 'CLOUD_BASIC':
          label = this.$t('customCluster.createCluster.diskType.basic');
          break;
        case 'CLOUD_PREMIUM':
          label = this.$t('customCluster.createCluster.diskType.premium');
          break;
        case 'CLOUD_BSSD':
          label = this.$t('customCluster.createCluster.diskType.bssd');
          break;
        case 'CLOUD_SSD':
          label = this.$t('customCluster.createCluster.diskType.ssd');
          break;
        case 'CLOUD_HSSD':
          label = this.$t('customCluster.createCluster.diskType.hssd');
          break;
        case 'CLOUD_TSSD':
          label = this.$t('customCluster.createCluster.diskType.tssd');
          break;
        default:
      }
      return label;
    },

    /**
     * 选择机型
     */
    changeInstanceDescription(type) {
      for (const key of this.instanceDescriptionOption) {
        if (key.value === type) {
          if (key.text.slice(0, key.text.indexOf(this.$t('customCluster.createCluster.core'))) === '1') {
            this.form.topology = true;
            this.notTopology = true;
          } else {
            this.notTopology = false;
          }
          // 新增字段
          this.newFields = {
            InstanceFamily: key.InstanceFamily,
            Cpu: key.Cpu,
            CpuType: key.CpuType,
            Gpu: key.Gpu,
            Memory: key.Memory,
          };
          this.form.thpcInstanceTypePrice = key.Price;

          this.getDescribeHpcClusters();
        }
      }
      this.checkPrice(this.form);
    },

    /**
     * 查询实例高性能计算集群信息
     */
    getDescribeHpcClusters() {
      postRequest('/api/eda/common/tencentcloud/describeHpcClusters', {
        region: this.form.region,
        zone: this.form.zone,
        instanceType: this.form.instanceDescription,
      }).then((res) => {
        this.hpcClustersList = res.hpcClustersList;
      });
    },

    /**
     * 修改系统盘
     */
    changeDisk() {
      this.form.diskSize = this.gibMinNumber;
      this.checkPrice(this.form);
    },

    /**
     * 修改系统盘大小
     */
    changeDiskSize() {
      this.checkPrice(this.form);
    },

    /**
     * 选择镜像类型
     */
    changeImageType(type) {
      this.form.imageId = '';
      if (type === 'imageType') {
        this.imagePlatformType = '';
        this.getImages();
      } else {
        if (this.imagePlatformType === '') {
          this.imageList = this.imageOptionList;
        } else {
          this.imageList = this.imageOptionList.filter(item => item.Platform === this.imagePlatformType);
        }
      }
    },

    /**
     * 选择镜像
     */
    changeImage(imageId) {
      // this.form.diskType = '';
      // this.form.diskSize = 1;
      this.imageList.forEach((item) => {
        if (item.ImageId === imageId) {
          this.imageSize = item.ImageSize;
          this.form.platform = item.Platform;
        }
      });
      if (this.form.diskType !== '' && this.form.diskSize < this.imageSize) {
        this.form.diskSize = this.imageSize;
      }
      this.gibMinNumber = this.imageSize;
      this.checkPrice(this.form);

      // 判断是不是已经填写过子网信息
      if (this.form.region !== '' && this.form.zone !== '') {
        // this.form.instanceType = '';
        // this.form.instanceDescription = '';
        // this.editInstanceTypeReset = true;

        // 获取机型列表
        this.getInstanceTypeList();
      }
    },

    /**
     * 获取镜像列表
     */
    getImages() {
      if (this.form.region === '') {
        return;
      }
      if (this.form.imageType === '') {
        return;
      }
      postRequest('/api/eda/common/tencentcloud/describeImages', {
        projectId: this.projectId,
        region: this.form.region,
        imageTypeList: [this.form.imageType],
      }).then((res) => {
        this.imageList = res.imageSet;
        this.changeImage(this.info.imageId);
        this.imageOptionList = [];
        const platformSet = new Set();
        platformSet.add(''); // 添加"全部"选项
        res?.imageSet.forEach((item) => {
          platformSet.add(item.Platform);
        });
        this.imageOptionList = this.imageList;
        this.imageTypeList = Array.from(platformSet).map(Platform => ({
          text: Platform === '' ? this.$t('common.all') : Platform,
          value: Platform,
        }));
      });
    },

    /**
     * 选择vpc
     */
    changeVpc() {
      this.form.subnetId = '';
      this.form.subnetCidrBlock = '';
      this.form.zone = '';
      this.getSubnet();
    },


    /**
     * 选择vpc下的子网
     */
    changeSubnet(subnet) {
      this.form.subnetCidrBlock = '';
      this.subnetList.forEach((item) => {
        if (item.SubnetId === subnet) {
          this.defaultHostRangeListForm = {
            startIp: [
              { value: '', disabled: true },
              { value: '', disabled: false },
              { value: '', disabled: false },
              { value: '' },
            ],
            endIp: [
              { value: '', disabled: true },
              { value: '', disabled: false },
              { value: '', disabled: false },
              { value: '' },
            ],
            hostnamePattern: '',
            indexStart: '',
            indexLength: '',
          };
          this.form.subnetCidrBlock = item.CidrBlock;
          const list = this.form.subnetCidrBlock.split('.');
          const section1 = list[0];
          const section2 = list[1];
          const section3 = list[2];
          const section4 = list[3].substring(list[3].indexOf('/') + 1) / 1;
          // 根据子网掩码长度设置IP地址段
          this.defaultHostRangeListForm.startIp[0].value = section1;
          this.defaultHostRangeListForm.endIp[0].value = section1;
          if (16 <= section4 < 24) {
            // 掩码长度大于16位，固定前两段IP
            this.defaultHostRangeListForm.startIp[1].disabled = true;
            this.defaultHostRangeListForm.endIp[1].disabled = true;
            this.defaultHostRangeListForm.startIp[1].value = section2;
            this.defaultHostRangeListForm.endIp[1].value = section2;
          }
          if (section4 >= 24) {
            // 掩码长度大于等于24位，固定前三段IP
            this.defaultHostRangeListForm.startIp[1].disabled = true;
            this.defaultHostRangeListForm.startIp[2].disabled = true;
            this.defaultHostRangeListForm.endIp[1].disabled = true;
            this.defaultHostRangeListForm.endIp[2].disabled = true;
            this.defaultHostRangeListForm.startIp[1].value = section2;
            this.defaultHostRangeListForm.startIp[2].value = section3;
            this.defaultHostRangeListForm.endIp[1].value = section2;
            this.defaultHostRangeListForm.endIp[2].value = section3;
          }
        }
      });
      this.checkPrice(this.form);
    },

    /**
     * 选择地区
     */
    changeZone() {
      this.form.subnetId = '';
      this.form.subnetCidrBlock = '';
      if (this.clusterType !== 'copy') {
        this.form.instanceType = '';
        this.form.instanceDescription = '';
      }
      this.diskList = '';
      this.getSubnet();
      this.getDisk();
      this.getInstanceTypeList();
      this.checkPrice(this.form);
    },

    /**
     * 预览IP*/
    preview() {
      // 将startIp中的4段value合并成IP字符串
      const startIp = this.showHostRangeListForm.startIp.map(ipPart => ipPart.value).join('.');
      const endIp = this.showHostRangeListForm.endIp.map(ipPart => ipPart.value).join('.');
      const ipList = {
        ...this.showHostRangeListForm,
        indexStart: +this.showHostRangeListForm.indexStart,
        endIp,
        startIp, // 添加合并后的IP字段
      };
      this.openPwDialog(this.generateIpArray(ipList));
    },

    /**
     * 选择地区
     */
    changeRegion() {
      this.form = {
        name: this.form.name,
        region: this.form.region,
        vpcId: '',
        imageType: '',
        imageId: '',
        diskType: '',
        diskSize: 0,
        instanceType: '',
        instanceDescription: '',
        securityGroupIds: [],
        subnetId: '',
        zone: '',
        hostnamePattern: '',
        startIp: '',
        endIp: '',
        topology: false,
        index: 1,
        indexDigit: 3,
        instanceChargeType: 'POSTPAID_BY_HOUR',
        subnetCidrBlock: '',
        instanceService: 'cvm',
        hpcClusterId: '',
      };
      this.notTopology = false;
      // 获取vpclist
      this.getVpcList();
      this.getSecurityGroup();
      this.getZones();
      this.getImages();
    },
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
    startIp() {
      return `${this.startIp1}.${this.startIp2}.${this.startIp3}.${this.startIp4}`;
    },
    endIp() {
      return `${this.endIp1}.${this.endIp2}.${this.endIp3}.${this.endIp4}`;
    },
  },
  mounted() {
    // 获取项目id
    const currentProject = this.getCurrentProject() || {};
    this.projectId = currentProject.id;
    this.currentProject = currentProject;
  },
};
</script>
<style lang="scss" scoped>
.endIp_div--list {
  position: absolute;
  top: 12px;
  left: 356px;
}

.div-marginLeft__-30 {
  margin-left: -30px;
}

.div-width__180 {
  width: 180px !important;
}

.preview_div--button {
  position: absolute;
  top: 12px;
  left: 630px;
}

.formItem__input-short {
  ::v-deep .el-input {
    width: 150px;
  }
}

.formItem__input-mini {
  ::v-deep .el-input__inner {
    text-align: center;
    -moz-appearance: textfield;
  }

  ::v-deep .el-input__inner::-webkit-inner-spin-button,
  ::v-deep .el-input__inner::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }

  ::v-deep .el-input {
    width: 60px;
  }
}

.formItem__select-short {
  width: 170px;
}

.formItem__select-long {
  width: 500px;
}

.tips_cls {
  color: #999;
  font-size: 10px;
  margin-bottom: 14px;
  margin-left: 60px;
}

.startIp_input {
  .el-input {
    margin-right: 10px;
    width: 54px;
  }

  ::v-deep .el-input__inner {
    text-align: center;
    -moz-appearance: textfield;
  }

  ::v-deep .el-input__inner::-webkit-inner-spin-button,
  ::v-deep .el-input__inner::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }
}

.tooltipBox {
  p {
    font-size: 12px;
    padding: 4px 0;
  }
}

.ipBox {
  height: 126px;
  padding: 8px;
  margin-bottom: 10px;

  span {
    line-height: 36px;
    margin-right: 8px;
  }
}

.box_clas {
  ::v-deep .el-step__title {
    font-size: 12px !important;
  }
}

.userDataTemplate-cls {
  width: 230px;
  border: 1px solid #dcdfe6;
  border-radius: 5.5px;
  font-size: 14px;
  height: 395px;
  overflow: auto;

  div {
    padding: 4px 8px;
    box-sizing: border-box;
    cursor: pointer;
  }

  div:hover {
    span {
      color: #2a83d4;
    }
  }
}
</style>
